import React, { Component } from 'react'
import { injectIntl } from 'react-intl'
import { withRouter } from 'react-router'
import { connect } from 'react-redux'
import { Modal, Button, Divider, Alert } from 'antd'
import { approvedRejectedUserRequest } from '../../actions/GroupAction'
import { setRequestIdToSend } from '../../actions/NotificationAction'
import { permissionTranslation } from '../../utils'
import { givingPermissions } from '../../actions/PermissionAction'

export class UserRequestManager extends Component {

  constructor(props) {
    super(props)
    this.state = {
      pageEnabled: true,
      btnClick: '',
      btnIdClick: ''
    }
  }

  componentDidMount() {
    this.setState({
      pageEnabled: !/^\/home\/groups/.test(this.props.location.pathname)
    })

    this.props.givingPermissions('HIDE')
  }

  componentDidUpdate(prevProps) {
    if (prevProps.location.pathname !== this.props.location.pathname) {
      this.setState({
        pageEnabled: !/^\/home\/groups/.test(this.props.location.pathname)
      })
    }
  }

  handleApproved = requestId => {
    const { intl } = this.props
    this.setState({
      btnClick: 'approved',
      btnIdClick: requestId,
    }, () => this.props.approvedRejectedUserRequest(requestId, 'approved', intl, true))
  }

  handleRejected = requestId => {
    const { intl } = this.props
    this.setState({
      btnClick: 'rejected',
      btnIdClick: requestId
    }, () => this.props.approvedRejectedUserRequest(requestId, 'rejected', intl, true))
  }

  handleDetailRequest = (groupId, requestId) => {
    this.props.setRequestIdToSend(requestId)
    this.props.history.push(`/home/groups/${groupId}`)
  }

  render() {
    const { showModal, userRequests, isFetching, intl } = this.props
    const { btnClick, btnIdClick, pageEnabled } = this.state
    const userRequestMessage = intl.formatMessage({ id: 'permission_request_user' })

    return (
      (pageEnabled && showModal)
        ?
        <Modal
          title={intl.formatMessage({ id: 'permission_request_management' })}
          visible={pageEnabled && showModal}
          width={700}
          footer={null}>
          {userRequests.map((r, k) => {
            return <div style={{ paddingBottom: 10 }} key={k}>
              <div style={{
                borderLeftStyle: 'solid',
                paddingLeft: 4,
                borderLeftColor: 'cornflowerblue',
                borderLeftWidth: 'thin'
              }}>
                {userRequestMessage.replace('#email#', `${r.userRequire.email}`).replace('#group#', `${r.group.name}`)}
                {r.permissions.map((row, x) => <b key={x}> {permissionTranslation(row, intl)}{r.permissions.length !== ++x && <span>, </span>}  </b>)}
              </div>
              <div style={{ marginTop: 10 }}>
                <Button
                  type="primary"
                  loading={isFetching && btnClick === 'approved' && btnIdClick === r._id}
                  onClick={() => this.handleApproved(r._id)}
                  size="small"
                  style={{ marginRight: 8 }}
                  icon="check-circle">{intl.formatMessage({ id: 'enable' })}
                </Button>
                <Button
                  type="danger"
                  size="small" loading={isFetching && btnClick === 'rejected' && btnIdClick === r._id} onClick={() => this.handleRejected(r._id)}
                  icon="stop">{intl.formatMessage({ id: 'not_enable' })}
                </Button>
                <Button
                  type="primary"
                  size="small"
                  onClick={() => this.handleDetailRequest(r.group.id, r._id)}
                  style={{ marginLeft: 8 }}>Ir a permisos</Button>
              </div>
              <div style={{ fontStyle: 'oblique', fontSize: 'smaller', marginTop: 10 }}>
                <Alert message={intl.formatMessage({ id: 'permission_request_alert' })} type="info" style={{ marginBottom: '10px', fontSize: "17px" }} />
              </div>
              {userRequests.length !== ++k && <Divider />}
            </div>
          })}
        </Modal>
        : <div></div>
    )
  }
}

const mapStateToProps = state => {
  return {
    userRequests: state.notifications.userRequests,
    showModal: state.notifications.showModal,
    isFetching: state.group.aprovvedRejectedIsFetching,
    openDetail: state.permission.openDetail
  }
}

const mapDispatchToProps = {
  approvedRejectedUserRequest,
  setRequestIdToSend,
  givingPermissions
}

export default injectIntl(withRouter(connect(mapStateToProps, mapDispatchToProps)(UserRequestManager)))